/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreatedReferralCodeDto } from '../models/work-created-referral-code-dto';
import { WorkReferral } from '../models/work-referral';
import { WorkReferralSummaryDto } from '../models/work-referral-summary-dto';

@Injectable({ providedIn: 'root' })
export class WorkReferralsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `referralsV2ControllerGetCreatedReferralsByContact()` */
  static readonly ReferralsV2ControllerGetCreatedReferralsByContactPath = '/v2/referrals/createdReferralsByContact/{contactId}';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `referralsV2ControllerGetCreatedReferralsByContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  referralsV2ControllerGetCreatedReferralsByContact$Response(
    params: {
      contactId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkReferral>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReferralsV2Service.ReferralsV2ControllerGetCreatedReferralsByContactPath, 'get');
    if (params) {
      rb.path('contactId', params.contactId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkReferral>>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `referralsV2ControllerGetCreatedReferralsByContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  referralsV2ControllerGetCreatedReferralsByContact(
    params: {
      contactId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkReferral>> {
    return this.referralsV2ControllerGetCreatedReferralsByContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkReferral>>): Array<WorkReferral> => r.body)
    );
  }

  /** Path part for operation `referralsV2ControllerGetReceivedReferralsByContact()` */
  static readonly ReferralsV2ControllerGetReceivedReferralsByContactPath = '/v2/referrals/receivedReferralsByContact/{contactId}';

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `referralsV2ControllerGetReceivedReferralsByContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  referralsV2ControllerGetReceivedReferralsByContact$Response(
    params: {
      contactId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkReferral>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReferralsV2Service.ReferralsV2ControllerGetReceivedReferralsByContactPath, 'get');
    if (params) {
      rb.path('contactId', params.contactId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkReferral>>;
      })
    );
  }

  /**
   * Required permissions: contacts:read, contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `referralsV2ControllerGetReceivedReferralsByContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  referralsV2ControllerGetReceivedReferralsByContact(
    params: {
      contactId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkReferral>> {
    return this.referralsV2ControllerGetReceivedReferralsByContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkReferral>>): Array<WorkReferral> => r.body)
    );
  }

  /** Path part for operation `referralsV2ControllerGetMyReferrals()` */
  static readonly ReferralsV2ControllerGetMyReferralsPath = '/v2/referrals/myReferrals';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `referralsV2ControllerGetMyReferrals()` instead.
   *
   * This method doesn't expect any request body.
   */
  referralsV2ControllerGetMyReferrals$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkReferralSummaryDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReferralsV2Service.ReferralsV2ControllerGetMyReferralsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkReferralSummaryDto>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `referralsV2ControllerGetMyReferrals$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  referralsV2ControllerGetMyReferrals(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkReferralSummaryDto>> {
    return this.referralsV2ControllerGetMyReferrals$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkReferralSummaryDto>>): Array<WorkReferralSummaryDto> => r.body)
    );
  }

  /** Path part for operation `referralsV2ControllerCreateReferralCode()` */
  static readonly ReferralsV2ControllerCreateReferralCodePath = '/v2/referrals/createReferralCode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `referralsV2ControllerCreateReferralCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  referralsV2ControllerCreateReferralCode$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCreatedReferralCodeDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReferralsV2Service.ReferralsV2ControllerCreateReferralCodePath, 'post');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCreatedReferralCodeDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `referralsV2ControllerCreateReferralCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  referralsV2ControllerCreateReferralCode(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkCreatedReferralCodeDto> {
    return this.referralsV2ControllerCreateReferralCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCreatedReferralCodeDto>): WorkCreatedReferralCodeDto => r.body)
    );
  }

  /** Path part for operation `referralsV2ControllerGenerateAndSendReferralCredit()` */
  static readonly ReferralsV2ControllerGenerateAndSendReferralCreditPath = '/v2/referrals/generateAndSendReferralCredit/{referralId}';

  /**
   * Required permissions: contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `referralsV2ControllerGenerateAndSendReferralCredit()` instead.
   *
   * This method doesn't expect any request body.
   */
  referralsV2ControllerGenerateAndSendReferralCredit$Response(
    params: {
      referralId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReferralsV2Service.ReferralsV2ControllerGenerateAndSendReferralCreditPath, 'post');
    if (params) {
      rb.path('referralId', params.referralId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `referralsV2ControllerGenerateAndSendReferralCredit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  referralsV2ControllerGenerateAndSendReferralCredit(
    params: {
      referralId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.referralsV2ControllerGenerateAndSendReferralCredit$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `referralsV2ControllerGenerateReferralCreditDocument()` */
  static readonly ReferralsV2ControllerGenerateReferralCreditDocumentPath = '/v2/referrals/generateReferralCreditDocument/{referralId}';

  /**
   * Required permissions: contacts:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `referralsV2ControllerGenerateReferralCreditDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  referralsV2ControllerGenerateReferralCreditDocument$Response(
    params: {
      referralId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Blob>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReferralsV2Service.ReferralsV2ControllerGenerateReferralCreditDocumentPath, 'post');
    if (params) {
      rb.path('referralId', params.referralId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'blob', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Required permissions: contacts:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `referralsV2ControllerGenerateReferralCreditDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  referralsV2ControllerGenerateReferralCreditDocument(
    params: {
      referralId: number;
    },
    context?: HttpContext
  ): Observable<Blob> {
    return this.referralsV2ControllerGenerateReferralCreditDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
